import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthoriseComponent } from './authorise.component';



@NgModule({
  declarations: [AuthoriseComponent],
  imports: [
    CommonModule
  ],
  exports: [AuthoriseComponent]
})
export class AuthoriseScreenModule { }
